import { queryPosts } from '@wix/ambassador-blog-v3-post-http/http';
import { PostFieldField } from '@wix/ambassador-blog-v3-post-http/types';
import { createAction, resolveId } from '@wix/communities-blog-client-common';
import { getCategoryIds } from '@app/external/common/store/categories/categories-selectors';
import { type NormalizedPost } from '@app/external/common/types';
import { normalizePosts } from '../../common/services/post-utils';
import { type PostPageThunkAction } from '../types';

export const FETCH_RELATED_POSTS_SUCCESS = 'relatedPosts/FETCH_SUCCESS';
export const FETCH_RELATED_POSTS_FAILURE = 'relatedPosts/FETCH_FAILURE';

export const fetchRelatedPostsRequest = createAction('relatedPosts/FETCH_REQUEST');
export const fetchRelatedPostsSuccess = createAction(
  FETCH_RELATED_POSTS_SUCCESS,
  (payload: NormalizedPost[], meta: { postId: string }) => payload,
  (payload, meta) => meta,
);
const fetchRelatedPostsFailure = createAction(
  FETCH_RELATED_POSTS_FAILURE,
  (payload: void, meta: { postId: string }) => payload,
  (payload, meta) => meta,
);

export default function fetchRelatedPosts(
  post: NormalizedPost,
  postCount?: number,
): PostPageThunkAction {
  return async (dispatch, getState, { httpClient, errorHandler }) => {
    const params = { postId: resolveId(post)! };
    const { withErrorHandler, showError } = errorHandler;
    dispatch(fetchRelatedPostsRequest(params));

    const postIds = post.relatedPostIds ?? [];
    const postIdsToFetch = postCount ? postIds.slice(0, postCount) : postIds;

    try {
      const response = await withErrorHandler(
        () =>
          httpClient.request(
            queryPosts({
              query: {
                filter: {
                  id: { $in: postIdsToFetch },
                },
                paging: { offset: 0, limit: postCount },
              },
              fieldsets: [PostFieldField.METRICS],
            }),
          ),
        { errorCodesMap: {} },
      );

      const normalizedPosts = normalizePosts({
        posts: response.data.posts,
        blogCategoryIds: getCategoryIds(getState()),
        origin: '/v3/posts',
      });

      dispatch(fetchRelatedPostsSuccess(normalizedPosts, params));
    } catch (error) {
      showError(error);
      dispatch(fetchRelatedPostsFailure(undefined, params));
    }
  };
}
